import { Error } from "../../../shared/Error";

export const ClientNotFound = () => {
  return (
    <Error
      error={{
        title: "Nie znaleziono klienta",
        message: "Spróbuj ponownie uruchomić aplikację",
      }}
    />
  );
};
